/**
 * Ikaros colourways: reveal the sold-out colours.
 *
 * The sold-out tiles ship in the markup with a hidden attribute rather than
 * being fetched on demand, so the count on the button is always truthful
 * and the reveal is instant. With JavaScript off the button never appears
 * and the in-stock colours - the ones a customer can actually buy - are
 * still all there, which is the state that matters.
 */

(() => {
  function wire(root) {
    const btn = root.querySelector('[data-ikcw-toggle]');
    if (!btn) return;

    const hiddenItems = [...root.querySelectorAll('[data-ikcw-hidden]')];
    if (!hiddenItems.length) {
      btn.remove();
      return;
    }

    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      hiddenItems.forEach((li) => {
        li.hidden = open;
      });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? btn.dataset.more : btn.dataset.less;
    });
  }

  function init() {
    document.querySelectorAll('[data-ikcw]:not([data-ikcw-ready])').forEach((root) => {
      root.setAttribute('data-ikcw-ready', 'true');
      try {
        wire(root);
      } catch (e) {
        console.warn('[ikaros-colourways]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['shopify:section:load', 'shopify:block:select'].forEach((evt) =>
    document.addEventListener(evt, init)
  );
})();
